export default __webpack_public_path__ + "static/media/terminal.9eebc42d.svg";